/**
 * Moves the product description card under the media gallery on desktop,
 * and restores it to its theme-editor position (before disclaimer) on mobile.
 * CSS hides the card while it is in the wrong column for the current breakpoint,
 * so DevTools / window resizes do not flash it under the gallery on mobile.
 */
class PdpProductDescription extends HTMLElement {
  /** @type {MediaQueryList | null} */
  #mq = null;
  /** @type {Comment | null} */
  #anchor = null;
  /** @type {HTMLElement | null} */
  #media = null;

  connectedCallback() {
    document.documentElement.classList.add('pdp-desc-relocate');

    this.#mq = window.matchMedia('(min-width: 750px)');
    this.#anchor = document.createComment('pdp-product-description-anchor');
    this.parentNode?.insertBefore(this.#anchor, this);
    this.#media = this.closest('.product-information')?.querySelector('.product-information__media') ?? null;

    this.#mq.addEventListener('change', this.#place);
    this.#place();
  }

  disconnectedCallback() {
    this.#mq?.removeEventListener('change', this.#place);
    this.#mq = null;
    this.#anchor = null;
    this.#media = null;
  }

  #place = () => {
    if (!this.#mq || !this.#anchor) return;

    if (this.#mq.matches && this.#media) {
      if (this.parentElement !== this.#media) {
        this.#media.appendChild(this);
      }
      this.dataset.placement = 'media';
      return;
    }

    if (this.#anchor.parentNode && this.parentNode !== this.#anchor.parentNode) {
      this.#anchor.parentNode.insertBefore(this, this.#anchor);
    }
    this.dataset.placement = 'details';
  };
}

if (!customElements.get('pdp-product-description')) {
  customElements.define('pdp-product-description', PdpProductDescription);
}
